<script>
  export let iconClass = '';
</script>

<svg xmlns="http://www.w3.org/2000/svg" class={iconClass} fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
  <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
</svg>